import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ActivityIndicator, Platform, Alert } from 'react-native';
import colors from '@/constants/Colors';

let Updates: any;
if (Platform.OS !== 'web') {
  Updates = require('expo-updates');
}

export function UpdateChecker() {
  const [isChecking, setIsChecking] = useState(false);
  const [lastCheckResult, setLastCheckResult] = useState<string | null>(null);

  if (Platform.OS === 'web') {
    return null;
  }

  const checkForUpdates = async () => {
    setIsChecking(true);
    setLastCheckResult(null);

    try {
      const update = await Updates.checkForUpdateAsync();

      if (update.isAvailable) {
        setLastCheckResult('Downloading update...');
        await Updates.fetchUpdateAsync();

        Alert.alert(
          'Update Available',
          'A new update has been downloaded. Would you like to restart the app now to apply it?',
          [
            {
              text: 'Later',
              style: 'cancel',
              onPress: () => {
                setLastCheckResult('Update downloaded. Restart to apply.');
                setIsChecking(false);
              }
            },
            {
              text: 'Restart Now',
              onPress: () => Updates.reloadAsync()
            },
          ],
          { cancelable: false }
        );
      } else {
        setLastCheckResult('Your app is up to date!');
        setIsChecking(false);
      }
    } catch (error) {
      console.error('Error checking for updates:', error);
      setLastCheckResult('Error checking for updates');
      setIsChecking(false);

      Alert.alert(
        'Update Check Failed',
        'Unable to check for updates. Please try again later.',
        [{ text: 'OK' }]
      );
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.heading}>Updates</Text>

      <TouchableOpacity
        style={[styles.button, isChecking && styles.buttonDisabled]}
        onPress={checkForUpdates}
        disabled={isChecking}
      >
        {isChecking ? (
          <View style={styles.buttonContent}>
            <ActivityIndicator color="#fff" size="small" />
            <Text style={styles.buttonText}>Checking...</Text>
          </View>
        ) : (
          <Text style={styles.buttonText}>Check for Updates</Text>
        )}
      </TouchableOpacity>

      {lastCheckResult && (
        <View style={styles.resultContainer}>
          <Text style={styles.resultText}>{lastCheckResult}</Text>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    padding: 16,
    borderRadius: 10,
    marginBottom: 16,
  },
  heading: {
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 12,
    color: '#222',
  },
  button: {
    backgroundColor: colors.primary,
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  buttonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  buttonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
  resultContainer: {
    marginTop: 12,
    padding: 12,
    backgroundColor: '#f5f5f5',
    borderRadius: 6,
  },
  resultText: {
    fontSize: 14,
    color: '#666',
    textAlign: 'center',
  },
});

